module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Tourists-4b95ca6dec618b7373124088be0c9aed.png";